import React from "react";
import { Box, Typography } from "@mui/material";
import {
  calculateOrderDiscountSummary,
  formatILS,
} from "../../helpers/orderDiscountHelper";

export default function OrderPriceWithDiscount({
  order,
  showTitle = false,
  onlyFinal = false,
}) {
  const summary = calculateOrderDiscountSummary(order);

  if (onlyFinal) {
    return (
      <Typography sx={{ fontSize: "1.2rem", fontWeight: "bold" }}>
        {formatILS(summary.finalTotal)}
      </Typography>
    );
  }

  if (!summary.isEligible || summary.discountAmount <= 0) {
    return (
      <Box>
        {showTitle && <Typography sx={{ fontWeight: "bold" }}>מחיר סופי:</Typography>}
        <Typography sx={{ fontSize: "1.2rem", fontWeight: "bold" }}>
          {formatILS(summary.finalTotal)}
        </Typography>
      </Box>
    );
  }  

  return (
    <Box>
      {showTitle && <Typography sx={{ fontWeight: "bold", mb: 1 }}>סיכום מחיר:</Typography>}

      <Typography>מחיר לפני הנחה: {formatILS(summary.subtotal)}</Typography>

      <Typography sx={{ color: "gray" }}>
        הנחת לקוח 5%: {formatILS(summary.discountAmount)}
      </Typography>

      <Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "green" }}>
        מחיר לאחר הנחה: {formatILS(summary.finalTotal)}
      </Typography>
    </Box>
  );
}